import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import WithCenter from '../layout/WithCenter';

import { Dispatch } from '../../store';

function FourOhOne() {
  const { t } = useTranslation();
  const dispatch = useDispatch<Dispatch>();
  const [seconds, setSeconds] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (seconds < 1) {
      dispatch({ type: 'ResetApp' });
      navigate('/login');
    } else {
      timer = setTimeout(() => {
        setSeconds((s) => s - 1);
      }, 1000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [seconds]);

  return (
    <WithCenter>
      <Trans i18nKey="errors.unauthorized">
        <>
          <p>Your session has expired and you have been logged out.</p>
          <p>
            You will be redirected to the login screen momentarily. Please login again to continue using the
            system.
          </p>
        </>
      </Trans>
      <Link to="/login">{t('go_to_login')}</Link>
      <p>
        <i>{t('redirect_to_login', { SECONDS: seconds })}</i>
      </p>
    </WithCenter>
  );
}

export default FourOhOne;
